import { render, staticRenderFns } from "./ThgSuccess.vue?vue&type=template&id=9dd2b284&scoped=true&"
import script from "./ThgSuccess.vue?vue&type=script&lang=ts&"
export * from "./ThgSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./ThgSuccess.vue?vue&type=style&index=0&id=9dd2b284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd2b284",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VIcon,VTextField})
